import { z } from 'zod';

import { TSDAddressSchema, TSDCommunicationSchema } from './utils';

export const TSDGeneralInfoSchema = z.object({
  customer: z.any(),

  generalInfo: z.object({
    ensReUseIndicator: z.boolean().optional().nullable(),
    declarationDate: z.any().optional().nullable(),
  }),

  supervisingCustomsOffice: z
    .object({
      referenceNumber: z.string().optional().nullable(),
    })
    .optional(),

  representative: z
    .object({
      identificationNumber: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      status: z.string().optional().nullable(),
      communication: TSDCommunicationSchema.optional(),
    })
    .optional(),

  locationOfGoods: z
    .object({
      typeOfLocation: z.string().optional().nullable(),
      qualifierOfIdentification: z.string().optional().nullable(),
      authorisationNumber: z.string().optional().nullable(),
      additionalIdentifier: z.string().optional().nullable(),
      UNLocode: z.string().optional().nullable(),
      customsOffice: z
        .object({
          referenceNumber: z.string().optional().nullable(),
        })
        .optional(),
      gnss: z
        .object({
          latitude: z.string().optional().nullable(),
          longitude: z.string().optional().nullable(),
        })
        .optional(),
      economicOperator: z
        .object({
          identificationNumber: z.string().optional().nullable(),
        })
        .optional(),
      address: TSDAddressSchema.optional(),
    })
    .optional(),

  arrivalTransportMeans: z
    .object({
      identificationNumber: z.string().optional().nullable(),
      typeOfIdentification: z.string().optional().nullable(),
      nationality: z.string().optional().nullable(),
      modeOfTransportAtTheBorder: z.string().optional().nullable(),
    })
    .optional(),

  warehouse: z
    .object({
      type: z.string().optional().nullable(),
      identifier: z.string().optional().nullable(),
    })
    .optional(),

  placeOfUnloading: z
    .object({
      UNLocode: z.string().optional().nullable(),
    })
    .optional(),

  personNotifyingTheArrivalAfterMovement: z
    .object({
      identificationNumber: z.string().optional().nullable(),
    })
    .optional(),

  declarantPerson: z
    .object({
      identificationNumber: z.string().optional().nullable(),
      name: z.string().optional().nullable(),
      communication: TSDCommunicationSchema.optional(),
    })
    .optional(),

  refreshCustomerData: z.boolean().optional().nullable(),
});
